var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-text-zan-exhibition-theme1",class:"template_"+_vm.templateId,on:{"click":_vm.actZan}},[_c('div',{staticClass:"icon",class:_vm.zan ? "on" : ""}),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }